import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationService, NotificationMessage } from '../../../services/notification.service';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-notification-toast',
  templateUrl: './notification-toast.component.html',
  styleUrls: ['./notification-toast.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateX(100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class NotificationToastComponent implements OnInit, OnDestroy {
  notifications: NotificationMessage[] = [];
  private subscription: Subscription = new Subscription();

  constructor(private notificationService: NotificationService) {}

  ngOnInit(): void {
    this.subscription = this.notificationService.notifications$.subscribe(
      notifications => {
        this.notifications = notifications;
      }
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * Hide a specific notification
   */
  hideNotification(id: string): void {
    this.notificationService.hideNotification(id);
  }

  /**
   * Hide all notifications
   */
  hideAllNotifications(): void {
    this.notificationService.hideAllNotifications();
  }

  /**
   * Get CSS class for notification type
   */
  getNotificationClass(type: string): string {
    switch (type) {
      case 'success':
        return 'notification-success';
      case 'error':
        return 'notification-error';
      case 'warning':
        return 'notification-warning';
      case 'info':
        return 'notification-info';
      default:
        return 'notification-info';
    }
  }

  /**
   * Get icon class for notification type
   */
  getIconClass(type: string): string {
    switch (type) {
      case 'success':
        return 'feather icon-check-circle';
      case 'error':
        return 'feather icon-x-circle';
      case 'warning':
        return 'feather icon-alert-triangle';
      case 'info':
        return 'feather icon-info';
      default:
        return 'feather icon-info';
    }
  }

  /**
   * Track by function for ngFor
   */
  trackByNotificationId(index: number, notification: NotificationMessage): string {
    return notification.id;
  }
}
